
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/color",
      function () {
        return require("private-next-pages/material-ui/customization/color.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/color"])
      });
    }
  